"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParsePlaidPurpose = exports.RequestLinkTokenError = exports.PlaidLinkPurpose = void 0;
/** Optional Link-session purpose; omit it to keep the caller's existing session. */
var PlaidLinkPurpose;
(function (PlaidLinkPurpose) {
    // TODO: the value keeps the original bundle name so deployed frontends keep working. Rename it behind an alias until clients roll over.
    PlaidLinkPurpose["cashbackBoostDepositBundleOriginationBankSource"] = "rewardsCheckingBundleOriginationBankSource";
})(PlaidLinkPurpose || (exports.PlaidLinkPurpose = PlaidLinkPurpose = {}));
var RequestLinkTokenError;
(function (RequestLinkTokenError) {
    /**
     * Aven backend could not communicate w/ Plaid's service due to a socket hang up
     */
    RequestLinkTokenError["socketHangUp"] = "socketHangUp";
    /**
     * If the request to Plaid to retrieve a link token succeeds, but there is no token
     * provided in the response
     */
    RequestLinkTokenError["tokenNotProvided"] = "tokenNotProvided";
    /**
     * An error that we don't explicitly handle yet
     */
    RequestLinkTokenError["genericError"] = "genericError";
})(RequestLinkTokenError || (exports.RequestLinkTokenError = RequestLinkTokenError = {}));
/** @TranslateToPython @TranslateToEnum */
var ParsePlaidPurpose;
(function (ParsePlaidPurpose) {
    ParsePlaidPurpose["INCOME"] = "INCOME";
    ParsePlaidPurpose["ADVISOR_LEAD_INCOME"] = "ADVISOR_LEAD_INCOME";
    ParsePlaidPurpose["ACCOUNT_DATA"] = "ACCOUNT_DATA";
    ParsePlaidPurpose["GET_TOP_MERCHANTS_BY_AMOUNT"] = "GET_TOP_MERCHANTS_BY_AMOUNT";
    ParsePlaidPurpose["GET_MOST_RECENT_FLOWS"] = "GET_MOST_RECENT_FLOWS";
    ParsePlaidPurpose["GET_BALANCES"] = "GET_BALANCES";
    ParsePlaidPurpose["GET_SUBSCRIPTIONS"] = "GET_SUBSCRIPTIONS";
    ParsePlaidPurpose["FIND_RECURRING_STREAM"] = "FIND_RECURRING_STREAM";
})(ParsePlaidPurpose || (exports.ParsePlaidPurpose = ParsePlaidPurpose = {}));
